import { Component, Input, OnInit } from '@angular/core';
import { CarregandoService } from '../services/carregando.service';
import { ArquivoService } from '../services/arquivo.service';
import { NotificacaoService } from '../services/notificacao.service';
import { TipoArquivo } from '../models/enum';
import { UtilitarioService } from '../services/utilitario.service';

@Component({
  selector: 'app-anexo-uploader',
  templateUrl: './anexo-uploader.component.html',
  styleUrls: ['./anexo-uploader.component.scss'],
})
export class AnexoUploaderComponent implements OnInit {
  @Input() anexos: any[];
  @Input() editavel: boolean;
  @Input() tipoArquivo: TipoArquivo;

  constructor(
    private carregandoService: CarregandoService,
    private arquivoService: ArquivoService,
    private notificacaoService: NotificacaoService,
    private utilitarioService: UtilitarioService,
  ) {}

  ngOnInit() {}

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event) {
    const anexos = event.target.files;
    this.prepareFilesList(anexos);
  }

  /**
   * Delete file from anexos list
   * @param index (File index)
   */
  deleteFile(index) {
    if (this.anexos[index].id) {
      this.anexos[index].excluido = true;
    } else {
      this.anexos.splice(index, 1);
    }
  }

  /**
   * Convert Files list to normal array list
   * @param anexos (Files List)
   */
  prepareFilesList(anexos: Array<any>) {
    for (const item of anexos) {
      item.progress = 0;
      item.descricao = item.name;
      this.anexos.push(item);
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  toggleEdit(anexo, campo) {
    anexo.editando = !anexo.editando;

    if (anexo.editando) {
      setTimeout(() => {
        const elementoAnexo = document.getElementById(campo) as HTMLInputElement;
        elementoAnexo.select();
      }, 100);
    }
  }

  buscarAnexosNaoExcluidos() {
    return this.anexos.filter((a) => !a.excluido);
  }

  baixarArquivo(anexo: any) {
    if (anexo.id) {
      this.carregandoService.mostra('baixarArquivo');
      this.arquivoService.baixarArquivo(anexo.id, this.tipoArquivo).subscribe(
        (arq) => {
          this.utilitarioService.saveBlob(arq, anexo.arquivo);
          this.carregandoService.esconde('baixarArquivo');
        },
        (erro) => {
          this.carregandoService.esconde('baixarArquivo');
          this.notificacaoService.erro(erro);
        },
      );
    } else {
      this.utilitarioService.saveBlob(anexo, anexo.name);
    }
  }

  visualizarArquivo(anexo: any) {
    if (anexo.id) {
      this.carregandoService.mostra('visualizarArquivo');
      this.arquivoService.baixarArquivo(anexo.id, this.tipoArquivo).subscribe(
        (arq) => {
          if (this.utilitarioService.ePDF(anexo.arquivo)) {
            this.utilitarioService.openBlobModal(arq, anexo.arquivo);
          } else if (this.utilitarioService.eImagem(anexo.arquivo)) {
            this.utilitarioService.mostrarImagemBlob(arq, anexo.arquivo);
          } else {
            this.utilitarioService.saveBlob(arq, anexo.arquivo);
          }
          this.carregandoService.esconde('visualizarArquivo');
        },
        (erro) => {
          this.carregandoService.esconde('visualizarArquivo');
          this.notificacaoService.erro(erro);
        },
      );
    } else {
      if (this.utilitarioService.ePDF(anexo.name)) {
        this.utilitarioService.openBlobModal(anexo, anexo.name);
      } else if (this.utilitarioService.eImagem(anexo.name)) {
        this.utilitarioService.mostrarImagemBlob(anexo, anexo.name);
      } else {
        this.utilitarioService.saveBlob(anexo, anexo.name);
      }
    }
  }
}
